import { setMetadata } from '@sheerid/jslib';

const METADATA_FIELDS = ['user_id', 'device_id', 'session_id', 'scope_id'];

export const setQueryStringMetadata = () => {
    const urlParams = new URLSearchParams(window.location.search);

    for (const field of METADATA_FIELDS) {
        const metadataFieldValue = urlParams.get(field);

        if (metadataFieldValue) {
            setMetadata({ [field]: metadataFieldValue });
        }
    }
};
